export default "__VITE_ASSET__DJXsK5Tb__"